import type { CSSProperties, ReactElement } from 'react'

interface SpinnerProps {
  width?: number | string
  height?: number | string
  className?: string
  style?: CSSProperties
}

export function Spinner ({
  width = 10,
  height = 10,
  className,
  style
}: SpinnerProps): ReactElement {
  return (
    <span
      className={className}
      style={{
        display: 'inline-block',
        width,
        height,
        border: '2px solid rgba(255, 255, 255, .35)',
        borderTopColor: '#fff',
        borderRadius: '50%',
        animation: 'spin .8s linear infinite',
        ...style
      }}
    />
  )
}
